import getConfig from 'next/config';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Pagination from '../shared/pagination.component';

const { publicRuntimeConfig } = getConfig();

const defaultPageSize = publicRuntimeConfig.DEFAULT_PAGINATION_PAGE_SIZE;

const RoomTypesPager = (props) => {
    const { children } = props;
    const pageSize = props.pageSize || defaultPageSize;
    const roomTypes = _.map(props.roomTypes, (roomType) => roomType);
    const numberOfPages = Math.ceil(_.size(roomTypes) / pageSize);
    let pageNumber = props.pageNumber || 1;
    pageNumber = pageNumber > numberOfPages ? numberOfPages : pageNumber;
    const roomTypesPage = roomTypes.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
    return (
        <div>
            {children(roomTypesPage)}
            <div className='room-types-pager-pagination-container'>
                <Pagination count={numberOfPages} page={pageNumber} />
            </div>
        </div>
    );
};

export default RoomTypesPager;

RoomTypesPager.propTypes = {
    children: PropTypes.any,
    pageSize: PropTypes.number,
    pageNumber: PropTypes.number,
    roomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

